const SectionCont1 = () => {
	return (
		<section className="sub-content cont1">
			<div className="sub-inner full">
				<div className="title-group">
					<p className="title">
						<span>New ERP, All-in-One BusinessWare</span>
					</p>
					<p className="desc">
						<span>디지털과 AI 시대에 새로운 경영패러다임을 준비하는</span>
					</p>
					<p className="desc">
						<span>새로운 Enterprise Solution</span>
					</p>
				</div>
				<div className="text-box">
					<p className="title">Stella :</p>
					<p className="desc align-left">
						스텔라(Stella)는 라틴어로 '별'을 의미합니다. <br />
						밤하늘의 북극성처럼, 스텔라는 기업이 나아갈 방향을 비추고 <br />
						성장의 나침반이 되어 드립니다.
					</p>
				</div>
			</div>
		</section>
	);
};

export default SectionCont1;
